/**
 * @description Creates a react query client provider
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { QueryClient, QueryCache, QueryClientProvider } from '@tanstack/react-query';

import ApiError from '@seccon/shared/utils/ApiError';
import { ToastContext } from '@seccon/core/contexts/toast';

/**
 * @description Creates a react query client provider
 */

const QueryProvider = ({ children }) => {
  const toastApi = React.useContext(ToastContext);

  const queryClient = React.useMemo(() => (
    new QueryClient({
      queryCache: new QueryCache({
        // When an API error is thrown during a query, display the error message as a toast notification
        // All other errors, simply log the error
        onError: (error) => {
          if (error instanceof ApiError) {
            toastApi.error(error.getMessage());
          } else {
            console.error(error);
          }
        }
      })
    })
  ), []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

QueryProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
export default QueryProvider;
